import React, { useState,useRef,useEffect } from "react";
import { useMsal } from "@azure/msal-react";

const ProfileDropdown = () => {
  const { accounts, instance } = useMsal();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  // Get the authenticated user's name
  const userName = accounts.length > 0 ? accounts[0].name : "Guest";

  // Logout function
  const handleLogout = () => {
     instance.logoutRedirect({
    postLogoutRedirectUri: "https://login.microsoftonline.com/common/oauth2/v2.0/logout", // ✅ Shows "You have signed out" page
    account: accounts[0], // Ensures signing out of the correct user
  });
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  return (
    <div ref={dropdownRef} style={{ position: "relative", display: "inline-block" }}>
      {/* Profile Name (Clickable) */}
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: "16px",
          fontWeight: "bold",
        }}
      >
        {userName} ▼
      </button>

      {/* Dropdown Menu */}
      {showDropdown && (
        <div
          style={{
            position: "absolute",
            right: 0,
            top: "30px",
            background: "grey",
            border: "1px solid #ddd",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "5px",
            padding: "10px",
            minWidth: "150px",
            zIndex: 1000,
          }}
        >
          <button
            onClick={handleLogout}
            style={{
              width: "100%",
              background: "black",
              color: "white",
              border: "none",
              padding: "8px",
              cursor: "pointer",
              borderRadius: "5px",
            }}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;